import { GET_LANGUAGE, GET_TRANSLATE } from '../store/gql/translate'
import { gqlSend } from '../store/gql/send'

const platform = 'hrms'

export const appFetchTranslateAPI = async (lang) => {
  const variables = {
    platform
  }

  return await gqlSend({
    query: GET_TRANSLATE,
    req: variables,
    headers: {
      lang
    }
  })
}

export const appFetchLanguageAPI = async () => {
  const variables = {
    platform
  }
  return await gqlSend({
    query: GET_LANGUAGE,
    req: variables
  })
}
